import React, { useState } from 'react'

export default function MyTabs({tabList, currentTab, onTabChange}) {
  //console.log('MyTabs', tabList);
  const [tab, setTab] = useState(currentTab);

  function tabClicked(ix) {
    //console.log('tabClicked', ix);
    setTab(ix);
    onTabChange(ix);
  }

  return (
    <div className='w-full h=[44px] px-4 py-2 flex flex-row justify-around'>
        {tabList.map((t,ix) => {
            const bg = (ix === tab) ? ' bg-blue-400' : '';
            return (
                <div
                    key={ix}
                    onClick={()=>tabClicked(ix)} 
                    className={'max-h-10 px-4 border-2 border-blue-600 text-l font-semibold text-center hover:cursor-pointer hover:bg-blue-200'+bg}>
                    {t}
                </div>
            )
        })}
    </div>
  )
}
